enum AccountingItemTypeCode {
  AccountPayable = 'AP',
  AccountReceivable = 'AR',
}

export default AccountingItemTypeCode;
export type VerifyAccountingItemTypeCode = Utils.VerifyExtends<
  Model.Enum.AccountingItemTypeCode,
  Utils.ValueOf<typeof AccountingItemTypeCode>
>;
